export default __webpack_public_path__ + "static/media/homedialysis01.f61963c1.svg";